(function () {
  function initialise(root) {
    if (!root || root.dataset.pfReady === 'true') return;
    root.dataset.pfReady = 'true';

    root.querySelectorAll('[data-pf-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-pf-slider-track]');
      var previous = slider.querySelector('[data-pf-prev]');
      var next = slider.querySelector('[data-pf-next]');
      if (!track || !previous || !next) return;

      var timer;
      var autoplay = slider.dataset.pfAutoplay === 'true';
      var pauseOnHover = slider.dataset.pfPauseHover !== 'false';
      var keepAutoplayWithVideo = slider.dataset.pfVideoAutoplay === 'true';
      var interval = Math.max(2, Number(slider.dataset.pfAutoplaySpeed) || 3) * 1000;
      var sliderIsVisible = !('IntersectionObserver' in window);

      function initialiseSliderVisibility() {
        if (!('IntersectionObserver' in window)) return;

        var visibilityObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sliderIsVisible = entry.isIntersecting;
            if (sliderIsVisible) startAutoplay();
            else stopAutoplay();
          });
        }, { rootMargin: '300px 0px', threshold: 0.01 });

        visibilityObserver.observe(slider);
      }

      function playVideo(video) {
        if (!keepAutoplayWithVideo || document.hidden || video.dataset.pfVisible !== 'true') return;
        var playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(function () {});
      }

      function hydrateVideo(video) {
        if (video.dataset.pfLoaded === 'true') {
          playVideo(video);
          return;
        }

        if (video.dataset.poster) {
          video.poster = video.dataset.poster;
          video.removeAttribute('data-poster');
        }

        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });

        video.dataset.pfLoaded = 'true';
        video.addEventListener('loadeddata', function () {
          video.classList.add('is-loaded');
        }, { once: true });
        video.load();
        playVideo(video);
      }

      function hydrateExternalVideo(template) {
        if (!template || !template.content) return;
        template.parentNode.insertBefore(template.content.cloneNode(true), template);
        template.remove();
      }

      function initialiseLazyMedia() {
        var targets = slider.querySelectorAll('[data-pf-lazy-video], [data-pf-lazy-external-video]');
        if (!targets.length) return;

        if (!('IntersectionObserver' in window)) {
          targets.forEach(function (target) {
            if (target.matches('[data-pf-lazy-video]')) {
              target.dataset.pfVisible = 'true';
              hydrateVideo(target);
            } else {
              hydrateExternalVideo(target);
            }
          });
          return;
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var target = entry.target;
            if (target.matches('[data-pf-lazy-video]')) {
              target.dataset.pfVisible = entry.isIntersecting ? 'true' : 'false';
              if (entry.isIntersecting) hydrateVideo(target);
              else if (target.dataset.pfLoaded === 'true') target.pause();
            } else if (entry.isIntersecting) {
              hydrateExternalVideo(target);
              observer.unobserve(target);
            }
          });
        }, { rootMargin: '300px 160px', threshold: 0.01 });

        targets.forEach(function (target) { observer.observe(target); });
      }

      function stepSize() {
        var firstItem = track.firstElementChild;
        if (!firstItem) return track.clientWidth * 0.86;
        var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
        return firstItem.getBoundingClientRect().width + gap;
      }

      function move(direction) {
        var step = stepSize();
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - step * 0.5;
        if (direction > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      function stopAutoplay() {
        if (timer) window.clearInterval(timer);
        timer = undefined;
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplay || !sliderIsVisible || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(function () { move(1); }, interval);
      }

      previous.addEventListener('click', function () {
        move(-1);
        startAutoplay();
      });
      next.addEventListener('click', function () {
        move(1);
        startAutoplay();
      });

      if (pauseOnHover) {
        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);
        slider.addEventListener('focusin', stopAutoplay);
        slider.addEventListener('focusout', startAutoplay);
      }

      slider.querySelectorAll('video').forEach(function (video) {
        if (keepAutoplayWithVideo) {
          video.muted = true;
          video.defaultMuted = true;
          video.controls = false;
          video.loop = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('controlslist', 'nofullscreen nodownload noremoteplayback');
          video.setAttribute('disablepictureinpicture', '');
          video.setAttribute('disableremoteplayback', '');
        } else {
          video.addEventListener('play', stopAutoplay);
          video.addEventListener('pause', startAutoplay);
          video.addEventListener('ended', startAutoplay);
        }
      });

      initialiseLazyMedia();
      initialiseSliderVisibility();

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
          slider.querySelectorAll('video[data-pf-loaded="true"]').forEach(function (video) { video.pause(); });
        } else {
          startAutoplay();
          slider.querySelectorAll('video[data-pf-visible="true"]').forEach(playVideo);
        }
      });

      startAutoplay();
    });

    root.querySelectorAll('[data-pf-scroll-product]').forEach(function (button) {
      button.addEventListener('click', function () {
        var product = document.querySelector('[id^="MainProduct-"]') || document.querySelector('[id^="ProductInfo-"]') || document.querySelector('product-info');
        if (product) product.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initialiseAll(scope) {
    (scope || document).querySelectorAll('[data-pf-story]').forEach(initialise);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  else initialiseAll(document);

  document.addEventListener('shopify:section:load', function (event) { initialiseAll(event.target); });
})();
